import React from 'react'
import PropTypes from 'prop-types';
import LogResult from '../LogResult/LogResult';
import { makeStyles } from '@material-ui/core/styles';
import { v4 as uuidv4 } from 'uuid';

const LogResults = (props) => {

    const useStyles = makeStyles((theme) => ({
        root: {
            marginTop: '1rem',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start'
        }
    }));

    const classes = useStyles();

    return (
        <div  className={classes.root}>
            {props.logs.length > 0 &&
                <>
                    {props.logs.map(log => (
                        <LogResult key={uuidv4()} delete={props.delete} log={log} />
                    ))}
                </>
            }
        </div>
    );
};

LogResults.propTypes = {
    logs: PropTypes.array,
    delete: PropTypes.func
};

export default LogResults;